import $ from "jquery";

import React from "react";
import ReactDOM from "react-dom";
import Ordering from "./components/Ordering";
import Noleggio from "./components/Noleggio";

window.addEventListener("DOMContentLoaded", () => {
  console.log("Mounting...");
  for (let element of document.getElementsByClassName("ordering-component")) {
    ReactDOM.render(
      <Ordering options={JSON.parse(element.getAttribute("options"))} />,
      element
    );
  }

  for (let element of document.getElementsByClassName("noleggio-component")) {
    ReactDOM.render(
      <Noleggio options={JSON.parse(element.getAttribute("options"))} />,
      element
    );
  }
});

$(function() {
  console.log("Init");

  $("li a").on('click', function() {
    $(".sidebar.is-leveltwo").removeClass("is-active");
    let id = $(this).data("target");
    $(id).addClass("is-active");
  });

  $(".back").on('click', function() {
    let sidebar = $(this).parent();

    if (!$(sidebar).hasClass("is-leveltwo")) {
      $(".sidebar").removeClass("is-active");
    } else {
      $(sidebar).removeClass("is-active");
    }
  });

  $(".navbar-burger").on('click', function() {
    $("#sidebar").toggleClass("is-active");
  });
});
